import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@ot/shared/utils';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'home', loadChildren: './homepage/homepage.module#HomepageModule' },

  {
    path: 'vehicles',
    loadChildren: '@ot/dashboard/features/vehicle#VehicleModule',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  },
  {
    path: 'business-accounts',
    loadChildren:
      '@ot/dashboard/features/business-account#BusinessAccountModule',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  },
  {
    path: 'administration',
    loadChildren: '@ot/dashboard/features/administration#AdministrationModule',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  },
  {
    path: 'error',
    loadChildren: '@ot/shared/features/error-handler#ErrorHandlerModule'
  },
  { path: '**', redirectTo: '/error?type=404&message=Page is not found' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
